
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-0.093 0 174.921 162","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M84.358 127.894c30.359 0 53.824-22.904 53.824-51.157 0-26.47-22.045-42.631-36.646-42.631-20.332 0-36.63 14.248-38.952 35.4-.43 3.917-3.538 7.202-7.482 7.174-6.556-.047-16.089-.103-22.123-.082-2.598.009-4.745-2.096-4.617-4.689.91-18.345 7.053-35.498 18.766-48.674C60.143 8.594 79.097 0 101.536 0c37.701 0 73.292 34.209 73.292 76.737 0 47.089-39.07 85.263-89.668 85.263-36.084 0-72.427-23.549-85.116-56.472a.707.707 0 01-.032-.382c.17-.974.505-1.864.835-2.74.48-1.274.95-2.52.882-3.955l-.22-4.586a5.588 5.588 0 013.243-5.329l1.834-.853a7.077 7.077 0 003.99-5.138c.615-3.363 3.571-5.808 7.022-5.808 5.39 0 10.076 3.579 11.836 8.667 8.473 24.49 21.943 42.49 54.924 42.49z","fill":"#fb6970"}})])
          )
        }
      }
    